import { InvitePatientFromMv } from 'domain/usecases/patient/invite-patient-from-mv'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteInvitePatientFromMv implements InvitePatientFromMv {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  add(params: InvitePatientFromMv.Params): Promise<InvitePatientFromMv.Model> {
    return this.patientRepository.invitePatientFromMV(params)
  }
}
